import { render } from "./DetailedAnswer.vue?vue&type=template&id=73174ba6&scoped=true"
import script from "./DetailedAnswer.vue?vue&type=script&lang=js"
export * from "./DetailedAnswer.vue?vue&type=script&lang=js"

import "./DetailedAnswer.vue?vue&type=style&index=0&id=73174ba6&scoped=true&lang=css"

import exportComponent from "/var/www/ca-quiz.staging.mindoza.net/releases/20240705152708/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73174ba6"]])

export default __exports__